import { gql } from '@apollo/client';

export const AUTOMATIC_USER_ALLOCATIONS_SAVED = gql`
  subscription automaticUserAllocationSaved {
    automaticUserAllocationSaved {
      automaticUserAllocations {
        automaticUserAllocationId
        dealerId
        userId
        offerResponsibleId
        offerInsuranceUserId
        offerAccountManagerId
        allUsers
      }
    }
  }
`;
